<template>
  <!-- topicManage add -->
  <div>
    <a-modal
      :title="modalTitle"
      :visible="visible"
      @ok="okfun"
      @cancel="closeFun"
      v-bind="this.$store.state.modalConfig"

    >
      <x-addEdit
        ref="addEdit"
        :itemLayout="$store.state.modal_ItemLayout"
        :formList="formList"
        :formKey="formKey"
        :addParam="addParam"
        :editParam="editParam"
        :detailParam="detailParam"
        :initReqHandle = 'initReqHandle'
         :isSubmitBtn="false"
      >
      <template slot="ttt" slot-scope="{formItem}">
        <a-form-item
         :label="formItem.label"
         v-bind="$store.state.modal_ItemLayout"
        >
            <a-switch  v-decorator="formItem.props" :checked="isChecked"  @change="switchClick($event)"/>
          </a-form-item>
      </template>
      </x-addEdit>
    </a-modal>
  </div>
</template>

<script>
import { findListItem, handleHttpMethod } from '@/utils/common';
import { fetchSelect } from '@/utils/mixins';
export default {
  name: 'agricultureMenuAdd',
  mixins: [fetchSelect],
  components: { },
  data () {
    return {
      initReqHandle: false,
      categoryId: undefined,

      modalTitle: '新建话题',
      isChecked: false,
      visible: false,
      lngLat: [],
      position: '',
      inputKey: {
        lng: 'mapLng',
        lat: 'mapLat',
        address: 'address'
      },
      formList: [
        {
          label: '话题名称',
          inputType: 'input',
          options: [],
          handle: '',
          placeholder: '请输入名称',
          props: ['title', {
            rules: [{ required: true, message: '请输入名称' }]
          }]
        }, {
          label: '话题描述',
          inputType: 'textarea',
          options: [],
          handle: '',
          placeholder: '请输入名称',
          props: ['describe', {
            rules: [{ required: false, message: '请输入至少5个字符' }]
          }]
        },
        {
          label: '设为推荐',
          inputType: 'switch',
          slot: 'ttt',
          options: [],
          handle: '',
          placeholder: '请输入名称',
          props: ['recommend', {
            rules: [{ required: false, message: '' }]
          }]
        },
        {
          label: '排序',
          inputType: 'input',
          options: [],
          handle: '',
          placeholder: '请输入',
          props: ['sort', {
            rules: [{ required: false, message: '请输入排序序号' }, { max: 5, message: '最多5位数' }, { pattern: this.REG.nonnegativeInteger, message: this.MESSAGE.nonnegativeInteger }]
          }]
        }

      ],
      formKey: {
        icon: undefined,
        title: undefined,
        sort: undefined,
        searchType: undefined,
        childType: undefined,
        categoryIds: undefined
      },
      addParam: {
        url: '/housekeep/circles/category',
        reqHandle: this.addreqHandle, // addParam、editParaM都会执行 reqHandle方法
        resHandle: this.ResHandle
      },
      editParam: {
        url: '/housekeep/circles/category/',
        pathParam: true,
        resHandle: this.ResHandle
      },
      detailParam: {
        url: '/housekeep/circles/category/',
        resHandle: this.detailResHandle // this.detailResHandle
      }
    };
  },
  created () {
  },
  methods: {
    switchClick (e) {
      this.isChecked = e;
    },
    okfun () {
      this.$refs.addEdit.form.validateFields((err, values) => {
        if (err) { return; }
        if (values.recommend) {
          values.recommend = 1;
        } else {
          values.recommend = 0;
        }
        if (this.categoryId) {
          this.$put({
            url: '/housekeep/circles/category/' + this.categoryId,
            params: {
              ...values
            }
          }).then((res) => {
            this.$message.success(res.msg);
            this.$emit('updateTable', res);
            this.closeFun();
          });
        } else {
          this.$post({
            url: '/housekeep/circles/category',
            params: {
              ...values
            }
          }).then((res) => {
            this.$message.success(res.msg);
            this.$emit('updateTable', res);
            this.closeFun();
          });
        }
      });
    },
    closeFun () {
      this.categoryId = undefined;
      this.visible = false;
    },
    show (row) {
      this.visible = true;
      if (row && row.categoryId) {
        this.modalTitle = '编辑话题';
        this.categoryId = row.categoryId;
        if (row.recommend == 1) {
          this.isChecked = true;
        } else {
          this.isChecked = false;
        }
        setTimeout(() => {
          this.$refs.addEdit.form.setFieldsValue({
            ...row
          });
        }, 100);
      } else {
        this.isChecked = false;
        this.modalTitle = '新建话题';
      }
    },
    ResHandle (res) {
      this.closeFun();
      this.$emit('updateTable', res);
      return res;
    },
    detailResHandle (res) {
      return res;
    },
    reqHandle (param) {
      return param;
    },
    addResHandle (res) {
      return res;
    },
    editResHandle (res) {
      return res;
    },
    addreqHandle (req) {
      return req;
    }
  }
};
</script>
<style lang="less" scoped>
</style>
